// All reports and contact/appeal messages go to ONE Formspree form; Formspree
// forwards every submission to the inbox that owns the form. No API key is
// needed (the form id in the URL is the only identifier), so this replaces the
// old Resend-based /api/send-report route completely.
//
// Override with NEXT_PUBLIC_FORMSPREE_ENDPOINT if you ever create a new form.
export const FORMSPREE_ENDPOINT =
  process.env.NEXT_PUBLIC_FORMSPREE_ENDPOINT || 'https://formspree.io/f/mqaqjnpk'

export type FormspreeResult = { ok: boolean; error?: string }

export async function sendToFormspree(fields: Record<string, unknown>): Promise<FormspreeResult> {
  // Formspree wants flat string values - anything else is stringified.
  const body: Record<string, string> = {}
  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    body[key] = typeof value === 'string' ? value : JSON.stringify(value)
  })

  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), 20000)
  try {
    const res = await fetch(FORMSPREE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      signal: controller.signal,
    })
    if (res.ok) return { ok: true }
    const data = await res.json().catch(() => ({} as any))
    const detail = Array.isArray(data?.errors) ? data.errors.map((e: any) => e?.message).filter(Boolean).join(', ') : ''
    return { ok: false, error: detail || `Formspree responded with ${res.status}` }
  } catch (err: any) {
    return { ok: false, error: err?.name === 'AbortError' ? 'Request timed out. Please try again.' : 'Network error. Please check your connection and try again.' }
  } finally {
    clearTimeout(timer)
  }
}
